import { render, staticRenderFns } from "./VTransactionModal.vue?vue&type=template&id=c76a6d5a&scoped=true"
import script from "./VTransactionModal.vue?vue&type=script&lang=js"
export * from "./VTransactionModal.vue?vue&type=script&lang=js"
import style0 from "./VTransactionModal.vue?vue&type=style&index=0&id=c76a6d5a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c76a6d5a",
  null
  
)

export default component.exports